import { useState } from "react";
import { serviceAreas } from "../../data";
export default function LocationModal() {
  const [pincode, setPincode] = useState("");
  const [areaResult, setAreaResult] = useState(null);
  return (
    <div className="modal fade" id="locationModal" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="modal-title fs-5">Check delivery area</h2>
            <button className="btn-close" data-bs-dismiss="modal" />
          </div>
          <div className="modal-body">
            <p className="text-secondary">
              We currently serve select Pune neighbourhoods.
            </p>
            <label className="form-label">Enter your pincode</label>
            <div className="input-group">
              <input
                className="form-control"
                inputMode="numeric"
                maxLength="6"
                value={pincode}
                onChange={(e) => {
                  setPincode(e.target.value);
                  setAreaResult(null);
                }}
                placeholder="e.g. 411045"
              />
              <button
                className="btn btn-dark"
                onClick={() =>
                  setAreaResult(
                    serviceAreas.find((area) => area.pincode === pincode) ||
                      false,
                  )
                }
              >
                Check
              </button>
            </div>
            {areaResult && (
              <div className="service-note mt-3">
                <i className="fa-solid fa-circle-check" /> Great! We deliver in{" "}
                {areaResult.area}.
              </div>
            )}
            {areaResult === false && (
              <div className="alert alert-warning mt-3 mb-0">
                <strong>We’re not delivering in your area yet.</strong>
                <button
                  className="btn btn-sm btn-outline-dark d-block mt-2"
                  onClick={() =>
                    localStorage.setItem("freshloop_area_request", pincode)
                  }
                >
                  Notify me when available
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
